module.exports = __webpack_public_path__ + "img/icon_assign_to_existing_back.svg";